/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTopologyRing2 = createReactComponent("topology-ring-2", "IconTopologyRing2", [
  ["path", { d: "M14 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", key: "svg-0" }],
  ["path", { d: "M7 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", key: "svg-1" }],
  ["path", { d: "M21 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", key: "svg-2" }],
  ["path", { d: "M7 18h10", key: "svg-3" }],
  ["path", { d: "M18 16l-5 -8", key: "svg-4" }],
  ["path", { d: "M11 8l-5 8", key: "svg-5" }]
]);

export { IconTopologyRing2 as default };
//# sourceMappingURL=IconTopologyRing2.js.map
